<template>
  <div class="show_order">
    <div class="order-wrap">
      <div class="top_steps">
        <span class="click_point" @click="goToIndex">{{
          TLang("演出首页", "my")
        }}</span>
        <span class="top_arrow_icon">
          <img :src="staticAssets.ImgObj.arrow_right" alt />
        </span>
        <span>{{ TLang("演出订单", "my") }}</span>
      </div>
      <div class="orderlist_left">
        <list-nav :currentCity="city_flag" />
      </div>
      <div class="orderlist_right">
        <div class="orderlist_right_top">
          <div class="right_top_left">
            <span class="order_all">{{ TLang("全部订单", "list") }}</span>
            <span class="order_wait_pay">
              {{ TLang("待支付", "list") }}
              <i class="wait_pay_account">({{ waitPay_count }})</i>
            </span>
          </div>
          <div class="right_top_right">
            <a
              href="javascript:;"
              class="history_order"
              :class="{ history_over: history_over_flag }"
              @click="getToHistory"
              @mouseover="historyMouseOver"
              @mouseleave="historyMouseLeave"
            >
              <img
                :src="
                  !history_over_flag
                    ? staticAssets.ImgObj.history_default
                    : staticAssets.ImgObj.history_select
                "
                alt
              />
              {{ TLang("历史订单", "list") }}
            </a>
            <div class="search_right" style="display: inline-block">
              <el-input
                :placeholder="TLang('请输入订单编号进行查询', 'orderConfirm')"
                v-model="inputNo"
                class="order_list_search"
                @blur="searchOrderNo"
                @keyup.enter.native="searchOrderNo"
              ></el-input>
              <img
                :src="staticAssets.ImgObj.no_search_icon"
                alt
                slot="suffix"
              />
            </div>
          </div>
        </div>
        <div class="orderlist_right_bottom">
          <div class="right_bottom_title">
            <span class="orderlist_title_item">{{
              TLang("票品详情", "my")
            }}</span>
            <span class="orderlist_title_item">{{ TLang("票档", "my") }}</span>
            <span class="orderlist_title_item">{{
              TLang("单价福豆", "my")
            }}</span>
            <span class="orderlist_title_item">{{
              TLang("总计福豆", "my")
            }}</span>
            <span
              class="orderlist_title_item orderlist_status"
              @click="getSelectClick"
            >
              {{ TLang(current_select_item, "my") }}
              <img
                :src="
                  select_click_flag
                    ? staticAssets.ImgObj.select_arrow_top
                    : staticAssets.ImgObj.select_arrow_bottom
                "
                alt
              />
              <div class="status_select" v-if="select_click_flag">
                <span
                  class="status_select_item"
                  v-for="(sItem, sIndex) in staticAssets.status_array"
                  :key="`sItem${sIndex}`"
                  :class="{
                    active_select_item: select_item_index == sIndex,
                    hover_background:
                      hover_flag == sIndex && select_item_index != sIndex,
                  }"
                  @click.prevent.stop="getStatusSelect(sIndex, sItem)"
                  @mouseover="stateMouseEnter(sIndex)"
                  @mouseleave="stateMouseOut(sIndex)"
                  >{{ TLang(sItem.name, "my") }}</span
                >
              </div>
            </span>
            <span class="orderlist_title_item">{{
              TLang("操作", "list")
            }}</span>
          </div>
          <div class="right_bottom_content">
            <div
              class="order_list_item"
              v-for="(listItem, lIndex) in orderDataArray"
              :key="`listItem${lIndex}`"
              :class="{
                list_item_first: lIndex == 0,
                list_item_end: lIndex == orderDataArray.length - 1,
              }"
            >
              <div class="order_list_item_top">
                <span>{{ TLang("订单号", "list") }}：</span>
                <span>{{ listItem.orderNo }}</span>
                <span class="order_time"
                  >{{ TLang("下单时间", "list") }}：</span
                >
                <span>{{ listItem.orderDate }}</span>
              </div>
              <div class="order_list_item_bottom">
                <div
                  class="ticket_detail"
                  @click="getToShopDetail(listItem.goodsId)"
                >
                  <div class="ticket_detail_left">
                    <img
                      :src="staticAssets.ImgObj.advance_icon"
                      alt
                      class="advance_tips"
                      v-if="listItem.projectType == 1"
                    />
                    <img :src="listItem.showPic" alt />
                  </div>
                  <div class="ticket_detail_right">
                    <p
                      class="info_title"
                      @mouseover="infoTitleOver(lIndex)"
                      @mouseleave="infoTitleLeave"
                      :class="{ active_mouse: info_title_index == lIndex }"
                    >
                      {{ listItem.projectName }}
                    </p>
                    <p class="info_date">{{ listItem.performName }}</p>
                    <p class="info_address">
                      {{ listItem.venueName }}
                      <span class="info_address_br"></span>
                      {{ listItem.cityName }}
                    </p>
                    <p class="info_level" v-if="false">
                      {{ TLang("票档", "my") }}
                      <span class="info_level_answer">{{
                        listItem.priceName
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="ticket_drama_name">
                  <div
                    v-for="(name_item, name_index) in listItem.priceList"
                    :key="`name${name_index}`"
                  >
                    <span>{{ name_item.priceName }}</span>
                  </div>
                </div>
                <div class="ticket_price">
                  <div
                    v-for="(price_item, price_index) in listItem.priceList"
                    :key="`name${price_index}`"
                  >
                    <i
                      class="bigPrice"
                      style="font-style: normal; font-size: 14px"
                      >{{ formatPrice(price_item.ticketPrice) }}</i
                    >
                    <i
                      class="smallPrice"
                      style="font-style: normal; font-size: 12px"
                      >{{ formatPrice(price_item.ticketPrice, "fixed") }}</i
                    >
                    <i style="font-style: normal; font-size: 14px"
                      >×{{ price_item.ticketCount }}</i
                    >
                  </div>
                </div>
                <div class="ticket_total">
                  {{
                    (listItem.totalPrice * 1000 + listItem.freight * 1000) /
                    1000
                  }}
                  <span v-if="!listItem.freight != true"
                    >({{ TLang("含运费", "my") }}:{{ listItem.freight }})</span
                  >
                </div>
                <div class="ticket_state">
                  <span
                    class="ticket_state_top"
                    :class="{
                      order_state_fail: listItem.orderStatusName == '退款失敗',
                      order_state_wait: listItem.orderStatus == 1,
                      order_state_refund:
                        listItem.orderStatusName == '申请退款' ||
                        listItem.orderStatus == 7,
                    }"
                    >{{ TLang(listItem.orderStatusName, "my") }}</span
                  >
                  <span
                    @click="getToOrderDetail(listItem.orderNo)"
                    class="ticket_state_detail"
                    >{{ TLang("订单详情", "list") }}</span
                  >
                  <span class="ticket_tags">{{ TLang("不退不换", "my") }}</span>
                </div>
                <div class="ticket_operate">
                  <p class="time_count_down" v-if="false">
                    <img :src="staticAssets.ImgObj.orderlist_time_img" alt />
                    <span>{{ TLang("剩余", "list") }}</span>
                    <time-down
                      :timeData="listItem.remainingTime"
                      :sourceData="listItem"
                      @cancelList="getUpDateList(listItem.orderNo)"
                    />
                  </p>
                  <p class="orderlist_btn" v-if="listItem.orderStatus == 1">
                    <a
                      href="javascript:;"
                      class="order_pay_btn"
                      @click="orderPay(listItem.orderNo)"
                      >{{ TLang("立即支付", "my") }}</a
                    >
                    <a
                      href="javascript:;"
                      class="order_cancel_btn"
                      @click="orderCancel(listItem.orderNo)"
                      >{{ TLang("取消订单", "list") }}</a
                    >
                  </p>
                </div>
              </div>
            </div>
            <!-- 加载中...... start-->
            <div class="bottom_content_empty" v-if="loadingStart">
              <p v-loading="loadingStart" style="margin-top: 300px"></p>
            </div>
            <!-- 加载中......end -->
            <div
              class="bottom_content_empty"
              v-if="
                orderDataArray.length < 1 && waitPay_count == 0 && !loadingStart
              "
            >
              <img
                v-if="staticAssets.ImgObj.list_empty_img"
                :src="staticAssets.ImgObj.list_empty_img"
                alt
              />
              <p>
                {{ TLang("还没有您的演出订单哦", "my") }}
                <br />{{ TLang("赶紧去购物吧", "list") }}
              </p>
              <a href="javascript:;" @click="goToIndex">{{
                TLang("去逛逛", "my")
              }}</a>
            </div>
          </div>
          <div
            class="pagination right_bottom_pagination"
            style="padding-top: 0; margin-top: 28px; height: 60px"
            v-show="listTotal > pageSize"
          >
            <pagination
              :total="listTotal"
              @current-change="currentChange"
              :pageSize="pageSize"
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title
      :visible.sync="confirmVisible"
      class="confirm_dialog"
      width="420px"
      center
    >
      <div slot="title" class="header-title">
        <span class="title-del title_confirm_del" @click="getDelClose">
          <img :src="staticAssets.ImgObj.pop_del_icon" alt />
        </span>
      </div>
      <div class="confirm_top">
        <img :src="staticAssets.ImgObj.confirm_error_img" alt />
        <div class="confirm_text confirm_text_error">
          {{ TLang("您要取消该订单吗", "address") }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="dialog_btn dialog_confirm"
          type="primary"
          @click="confirmVisible = false"
          >{{ TLang("暂不取消", "my") }}</el-button
        >
        <el-button
          class="dialog_btn dialog_cancel"
          @click="confirmCancelOrder(null)"
          >{{ TLang("取消订单", "list") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "OrderInfo",
  data() {
    return {
      loadingStart: true, //加载
      tableData: this.sourceData,
      payOrRefund_way: this.payOrRefund,
      active_flag: 6,
      inputNo: null, //订单号字段
      info_title_index: null, //当前mouse的下标
      confirmVisible: false, //confirm的dialog开关
      history_over_flag: false, //历史订单的mouseOver事件
      total: 0, //分页总数
      select_item_index: 0, //列表当前状态
      hover_flag: null, //列表当前hover状态
      select_click_flag: false, //是否点击下拉选择
      current_select_item: this.TLang("全部订单", "list"),
      cancel_order_flag: null,
      waitPay_count: null, //待支付数量
      currnet_city: "", //当前城市,
      crrentStatus: null, //当前订单状态
      city_flag: "", //当前城市
      orderDataArray: [],
      listTotal: 0,
      userId: 1,
      pageSize: 10,
      pageIndex: 1,
    };
  },
  props: ["sourceData", "payOrRefund"],
  watch: {
    payOrRefund(val) {
      this.payOrRefund_way = val;
    },
  },
  components: {
    listNav: () => import("./OrderListNav.vue"), //左侧导航列表
    timeDown: () => import("./ListCountDown.vue"), //倒计时
    pagination: () => import("../../components/showList/pagination.vue"), //分页 暂时不要
  },
  beforeCreate() {
    //开启加载动画
    //this.publicMethod.openLoading();
  },
  created() {
    this.getListOrder(
      this.userId,
      null,
      this.inputNo,
      this.pageIndex,
      this.pageSize
    );
    this.currnet_city == this.$route.query.city;
    this.city_flag = this.$route.query.city;
  },
  // 移除滚动事件
  destroyed() {},
  computed: {},
  methods: {
    currentChange(page) {
      this.pageIndex = page;
      //this.loadingStart = true; //开启加载
      this.getListOrder(
        this.userId,
        this.crrentStatus,
        this.inputNo,
        this.pageIndex,
        this.pageSize
      ); //获取订单数据
      //document.body.scrollTop = 0;
      // document.documentElement.scrollTop = 0;
      // window.scrollTo({
      //   top: 0,
      //   behavior: "smooth"
      // });
    },
    //选择状态mouseEnter
    stateMouseEnter(val) {
      this.hover_flag = val;
    },
    //选择状态mouseOut
    stateMouseOut() {},
    //删除的关闭
    getDelClose() {
      this.confirmVisible = false;
    },
    //历史订单mouseEnter
    historyMouseOver() {
      this.history_over_flag = true;
    },
    //历史订单mouseLeave
    historyMouseLeave() {
      this.history_over_flag = false;
    },
    //跳转历史订单
    getToHistory() {
      //let test = window.location.href;
      window.df_sdk_common.location.href =
        window.location.origin +
        `/user/center/order/drama?city=${this.$route.query.city}`;
    },
    //去逛逛 返回首页
    goToIndex() {
      this.$router.push({
        path: "/home",
        query: {},
      });
    },

    //规格化价格
    formatPrice(val, fixed) {
      !val ? (val = "0.00") : val;
      let valNum = null;
      if (!fixed) {
        val.toString().indexOf(".") != -1
          ? (valNum = val.toString().slice(0, val.toString().indexOf(".")))
          : (valNum = val);
      } else {
        val.toString().indexOf(".") != -1
          ? (valNum = val.toString().slice(val.toString().indexOf(".")))
          : (valNum = ".00");
      }
      return valNum;
    },
    //点击状态下拉事件
    getSelectClick() {
      this.select_click_flag = !this.select_click_flag;
    },
    //切换当前列表状态
    getStatusSelect(val, vName) {
      this.listTotal = 0; //隐藏分页
      this.select_click_flag = !this.select_click_flag;
      this.select_item_index = val;
      this.current_select_item = vName.name;
      !this.inputNo ? (this.inputNo = null) : (this.inputNo = this.inputNo); //判断当前订单号是否是空字符串
      this.orderDataArray = []; //置空订单数据
      this.loadingStart = true; //开启加载
      this.crrentStatus = vName.id;
      this.getListOrder(this.userId, vName.id, this.inputNo, 1, 10); //获取订单数据
    },
    //查询订单号
    searchOrderNo() {
      this.loadingStart = true; //开启加载
      this.listTotal = 0; //隐藏分页
      !this.inputNo ? (this.inputNo = null) : (this.inputNo = this.inputNo); //判断当前订单号是否是空字符串
      this.getListOrder(this.userId, null, this.inputNo, 1, 10);
    },
    //获取订单列表信息
    getListOrder(uId, oState, oNo, pIndex, pSize) {
      let listSource = {
        userId: uId,
        orderStatus: oState,
        orderNo: oNo,
        pageNumber: pIndex,
        pageSize: pSize,
      };
      this.apis.showOrder.getListOrder(listSource).then((res) => {
        if (!res.code) {
          this.orderDataArray =
            res.body.data.length < 1 || res.body.data == null
              ? []
              : res.body.data;
          this.listTotal = res.body.count;
          this.waitPay_count =
            res.body.data.length > 0 ? res.body.data[0].unPayCount : 0;
          this.loadingStart = false; //关闭加载
        } else if (res && res.code && res.code === 101002) {
          this.loadingStart = false; //关闭加载
          let baseOrigin = window.location.origin;
          this.$message({
            showClose: true,
            message: this.TLang("请重新登录", "home"),
            type: "error",
            onClose: () => {
              window.df_sdk_common.location.href = `${baseOrigin}/user/login?city=${
                this.$route.query.city
              }&return_url=${encodeURIComponent(window.location.href)}`;
            },
          });
        }
      });
    },
    //跳转商品详情
    getToShopDetail(sId) {
      this.$router.push({
        path: "/detail",
        query: { id: sId },
      });
    },
    //跳转订单详情
    getToOrderDetail(val) {
      this.$router.push({
        path: "/order/pay",
        query: { orderNo: val },
      });
    },
    //立即支付
    orderPay(val) {
      let cancelData = {
        platform: 0, //平台0默认PC
        orderNo: val,
      };
      this.apis.showOrder.getPayOrder(cancelData).then((res) => {
        if (!res.code) {
          window.df_sdk_common.location.href = res.body.payUrl;
        }
      });
    },
    //取消订单
    orderCancel(val) {
      this.confirmVisible = true;
      this.cancel_order_flag = val;
    },
    //倒计时结束刷新列表
    getUpDateList() {
      this.getListOrder(this.userId, null, this.inputNo, 1, 10);
    },
    //确认取消订单
    confirmCancelOrder(valNo) {
      let cancelData = {
        orderNo: !valNo ? this.cancel_order_flag : valNo,
      };
      this.apis.showOrder.getCancelOrder(cancelData).then((res) => {
        if (!res.code) {
          this.publicMethod.getThrowInfo(
            TLang("取消订单成功", "my"),
            "success"
          );
          this.confirmVisible = false; //关闭弹层
          //取消订单成功后重新拉取订单列表
          this.$nextTick(() => {
            this.getListOrder(this.userId, null, this.inputNo, 1, 10);
          });
        }
      });
    },
    //标题mouseover事件
    infoTitleOver(val) {
      this.info_title_index = val;
    },
    //标题mouseout
    infoTitleLeave() {
      this.info_title_index = null;
    },
  },
};
</script>

<style scoped lang="less">
.ticket_tags {
  margin: 12px auto;
  display: block;
  width: 64px;
  // height: 22px;
  border-radius: 11px;
  background-color: rgba(255, 175, 0, 0.1);
  color: rgba(255, 175, 0, 1);
}
.pagination {
  height: 80px;
  margin-top: 24px;
  padding-top: 24px;
  .page {
    text-align: right;
  }
}
.line-clamp(@line: 2) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: @line;
  overflow: hidden;
  text-overflow: ellipsis;
}

.order-wrap {
  width: 1200px;
  margin: 0 auto;
}
.top_steps {
  margin: 0 0 20px 0;
  .click_point {
    cursor: pointer;
  }
  span {
    font-size: 14px;
    color: #666;
    line-height: 14px;
    display: inline-block;
  }

  .top_arrow_icon img {
    width: 14px;
    height: 14px;
    margin: 0px 5px;
  }
}
.order-wrap::after,
.orderlist_right_top::after {
  content: "";
  display: block;
  overflow: hidden;
  clear: both;
}
.orderlist_left,
.orderlist_right {
  float: left;
}
.orderlist_right {
  margin-left: 20px;
  width: 1000px;
}
.orderlist_right_top {
  width: 100%;
  .right_top_left {
    float: left;
    .order_all {
      display: inline-block;
      .drama_font_style(inherit, bold, 20px, 40px);
      height: 40px;
      position: relative;
      color: rgba(17, 17, 17, 1);
      margin-right: 40px;
    }
    .order_all::after {
      content: "";
      display: block;
      .drama_position_attr(absolute, auto, auto, 0, 0);
      width: 100%;
      height: 4px;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
    }
    .order_wait_pay {
      font-size: 20px;
      color: rgba(153, 153, 153, 1);
    }
    .wait_pay_account {
      color: #f44545;
      font-style: normal;
    }
  }
  .right_top_right {
    float: right;
    .history_over {
      color: rgba(38, 142, 231, 1) !important;
      background: rgba(236, 245, 253, 1) !important;
    }
    .history_order {
      .drama_wrap_attr(88px, 32px, 32px, 12px, rgba(17, 17, 17, 1), inherit);
      display: inline-block;
      text-align: center;
      background: rgba(247, 247, 247, 1);
      border-radius: 2px;
      margin-right: 16px;
      img {
        width: 12px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 2px;
      }
    }
    .search_right {
      width: 250px;
      position: relative;
      img {
        .drama_position_attr(absolute, 9px, 10px, auto, auto);
        width: 16px;
        height: 16px;
      }
    }
    .order_list_search {
      width: 250px;
    }
    /deep/ .order_list_search .el-input__inner {
      font-size: 12px;
      width: 250px;
      height: 32px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(204, 204, 204, 1);
      padding-left: 12px !important;
      padding-right: 10px !important;
    }
    /deep/ .order_list_search .el-input__icon {
      line-height: 32px !important;
    }
  }
}
.orderlist_right_bottom {
  margin-top: 16px;
  .right_bottom_title {
    .drama_wrap_attr(1000px, 50px, 50px, 12px, rgba(102, 102, 102, 1), inherit);
    background: rgba(241, 242, 243, 1);
    span {
      display: inline-block;
      text-align: center;
    }
    .orderlist_status {
      position: relative;
      cursor: pointer;
      img {
        width: 12px;
        height: 12px;
        margin-bottom: 2px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .status_select {
      z-index: 99;
      border-bottom: 1px solid #e5e5e5;
      .drama_position_attr(absolute, 50px, auto, auto, 0);
      width: 92px;
      height: 280px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
      .status_select_item {
        .drama_wrap_attr(100%, 40px, 40px, 14px, rgba(51, 51, 51, 1), inherit);
        cursor: pointer;
        text-align: center;
        display: block;
        border-right: 1px solid #e5e5e5;
        border-left: 1px solid #e5e5e5;
      }
      .active_select_item {
        border-right: 1px solid rgba(61, 150, 226, 1);
        border-left: 1px solid rgba(61, 150, 226, 1);
        background: rgba(61, 150, 226, 1);
        color: rgba(255, 255, 255, 1);
      }
      .hover_background {
        background: #ecf5fd;
      }
    }
  }
  .right_bottom_title .orderlist_title_item:nth-of-type(1),
  .ticket_detail {
    width: 440px;
    padding-left: 16px;
    text-align: left;
  }
  .right_bottom_title .orderlist_title_item:nth-of-type(2),
  .ticket_drama_name {
    width: 124px;
  }
  .right_bottom_title .orderlist_title_item:nth-of-type(3),
  .ticket_price {
    width: 120px;
  }
  .right_bottom_title .orderlist_title_item:nth-of-type(4),
  .ticket_total {
    width: 108px;
    span {
      .drama_wrap_attr(auto, 17px, 16px, 12px, rgba(153, 153, 153, 1), 500);
      margin-top: 11px;
      display: block;
    }
  }
  .right_bottom_title .orderlist_title_item:nth-of-type(5),
  .ticket_state {
    width: 88px;
  }
  .right_bottom_title .orderlist_title_item:nth-of-type(6),
  .ticket_operate {
    width: 120px;
  }
  .right_bottom_content {
    .bottom_content_empty {
      margin: 179px auto 0;
      text-align: center;
      img {
        width: 260px;
        display: inline-block;
        vertical-align: middle;
      }
      p {
        font-size: 15px;
        color: rgba(153, 153, 153, 1);
        line-height: 26px;
      }
      a {
        .drama_wrap_attr(120px, 40px, 40px, 14px, rgba(255, 255, 255, 1), bold);
        margin-top: 51px;
        display: inline-block;
        text-align: center;
        background: linear-gradient(
          315deg,
          rgba(92, 180, 236, 1) 0%,
          rgba(61, 150, 226, 1) 100%
        );
        border-radius: 4px;
      }
    }
    .list_item_first {
      margin-top: 17px;
    }
    .list_item_end {
      margin-bottom: 28px !important;
    }
    .order_list_item {
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(229, 229, 229, 1);
      margin-bottom: 31px;
      .order_list_item_top {
        .drama_wrap_attr(998px, 40px, 40px, 12px, rgba(153, 153, 153, 1));
        padding-left: 15px;
        background: rgba(247, 247, 247, 1);
        .order_time {
          margin-left: 32px;
        }
      }
      .order_list_item_bottom {
        .ticket_detail,
        .ticket_drama_name,
        .ticket_price,
        .ticket_total,
        .ticket_state,
        .ticket_operate {
          padding-top: 20px;
          position: relative;
          text-align: center;
          padding-bottom: 20px;
        }
        .ticket_detail::after,
        .ticket_drama_name::after,
        .ticket_price::after,
        .ticket_total::after,
        .ticket_state::after {
          content: "";
          display: block;
          width: 1px;
          height: 100%;
          background: rgba(247, 247, 247, 1);
          .drama_position_attr(absolute, 0, 0, auto, auto);
        }
        .ticket_detail {
          cursor: pointer;
          .ticket_detail_right {
            .drama_wrap_attr(308px, auto, 14px, 12px, rgba(102, 102, 102, 1));
            text-align: left;
            float: left;
            .info_title {
              .drama_wrap_attr(auto, 40px, 22px, 14px, rgba(17, 17, 17, 1));
              cursor: pointer;
              .line-clamp(@line: 2);
            }
            .active_mouse {
              color: #3d96e2;
            }
            .info_date {
              line-height: 14px;
              margin: 4px 0 2px;
            }
            .info_address {
              line-height: 16px;
              margin-bottom: 20px;
              .info_address_br {
                width: 1px;
                height: 10px;
                background: rgba(203, 205, 206, 1);
                display: inline-block;
                margin: 0 4px;
              }
            }
            .info_level {
              line-height: 17px;
            }
          }
          .ticket_detail_left {
            float: left;
            margin-right: 16px;
            width: 80px;
            position: relative;

            img {
              margin-top: 4px;
              width: 100%;
              vertical-align: middle;
              display: inline-block;
            }
            .advance_tips {
              width: 28px;
              height: 16px;
              .drama_position_attr(absolute, 0, 0, auto, auto);
            }
          }
        }
        .ticket_total {
          font-weight: bold;
          color: rgba(17, 17, 17, 1);
        }
        .ticket_state {
          color: rgba(51, 51, 51, 1);
          .ticket_state_detail {
            cursor: pointer;
          }
          .ticket_state_tag {
            .drama_wrap_attr(64px, 22px, 22px, 12px, rgba(255, 175, 0, 1), 500);
            background: rgba(255, 175, 0, 0.1);
            border-radius: 11px;
            margin-left: 12px;
            margin-top: 12px;
            text-align: center;
          }
        }
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
        display: flex;
        .ticket_state,
        .ticket_operate {
          display: flex;
          flex-direction: column;
          .time_count_down,
          .orderlist_btn {
            display: flex;
          }
          .orderlist_btn {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            a {
              .drama_wrap_attr(88px, 32px, 32px, 14px, rgba(153, 153, 153, 1));
              text-align: center;
              display: inline-block;
              border-radius: 2px;
            }
            .order_pay_btn {
              background: linear-gradient(
                315deg,
                rgba(92, 180, 236, 1) 0%,
                rgba(61, 150, 226, 1) 100%
              );
              font-weight: bold;
              color: rgba(255, 255, 255, 1);
              margin-bottom: 12px;
            }
            .order_cancel_btn {
              border: 1px solid rgba(229, 229, 229, 1);
              margin-bottom: 7px;
            }
          }
          .time_count_down {
            margin-bottom: 12px;
            justify-content: center;
            img {
              margin-top: 4px;
              width: 12px;
              height: 12px;
              display: inline-block;
              vertical-align: middle;
              margin-right: 4px;
            }
            span {
              display: inline-block;
              font-size: 14px;
              color: rgba(102, 102, 102, 1);
              line-height: 19px;
            }
            .source_time {
              color: #f44545;
              margin-left: 4px;
            }
          }
        }
        .ticket_state .ticket_state_top {
          margin-bottom: 12px;
        }
        .ticket_state .order_state_fail {
          color: rgba(153, 153, 153, 1);
        }
        .ticket_state .order_state_wait {
          color: rgba(244, 69, 69, 1);
        }
        .ticket_state .order_state_refund {
          color: rgba(61, 150, 226, 1);
        }
      }
    }
  }
}
.dialog_btn {
  width: 120px;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
}
.dialog_confirm {
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  background: #3FA6FF;
  background: var(--df-primary-color, #3FA6FF);
  border-color: #3FA6FF;
  border-color: var(--df-primary-color, #3FA6FF);
  margin-right: 20px;
}
.dialog_cancel {
  border: 1px solid rgba(229, 229, 229, 1);
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.confirm_top {
  text-align: center;
  img {
    width: 68px;
    display: inline-block;
    vertical-align: middle;
  }
  .confirm_text {
    margin: 18px auto 36px;
    .drama_wrap_attr(auto, auto, 25px, 18px, rgba(51, 51, 51, 1), 400);
  }
  .confirm_text_error {
    margin-top: 16px !important;
  }
}
/deep/ .el-dialog {
  .drama_position_attr(absolute, 50%, auto, auto, 50%);
  transform: translate(-50%, -50%);
  margin: 0 !important;
}
/deep/ .el-dialog__header {
  font-size: 18px;
  color: rgba(17, 17, 17, 1);
  line-height: 24px;
  padding: 16px 20px;
  position: relative;
}
/deep/ .el-dialog__body {
  padding: 0px 61px 4px;
}
/deep/ .el-dialog__footer {
  margin-bottom: 23px;
  padding-top: 0;
}
</style>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  font-weight: 500;
}
* .dialog_confirm {
  span {
    font-weight: bold !important;
    display: inline-block;
  }
}
.header-title .title-del {
  width: 28px;
  height: 28px;
  background: #ffffff;
  .drama_position_attr(absolute, 11px, 11px, auto, auto);
  z-index: 99;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
